/*
Sohel 11/03/2022 2699761741 Added Event Type lookUp
akhila 12/21/2022 2699761741 Added returnType lookUp
Sai maheshwar 01/06/2023 2701334326 added function lookup
Sohel 01/30/2023 2701334326 added Record Separator LookUP
Akhila 03/20/2023 2701334326 added letter maintenance LookUP
Sohel 03/31/2023 2701334326 Action Dropdown Changes
Sohel 04/04/2023 2701334326 added account status Dropdown
Ravi 05/23/2023 2701334326 Added Export Format file Field
Sohel 06/03/2023 2701334326 Added Amount Format Field
Sohel 09/24/2023 5155351299 Added Data Repository Lookup
Sohel 10/30/2023 5314488544 Added Eligibilty Status Lookup
sohel 11/07/2023 5314488544 lookup api changes for Eligibilty reviewed status

*/
export const DISPOSITION_CODE = 'GHI_DISPOSITION';
export const FREQUENCY = 'FREQUENCY';
export const CLOSURE_CODE = 'CLOSURE_CODE';
export const MARITAL_STATUS = 'MARITAL_STATUS';
export const LEGAL_TYPE = 'LEGAL_TYPE';
export const STATE = 'STATE';
export const PHONE_TYPE = 'PHONE_TYPE';
export const CREDIT_REPORTING = 'CREDIT_REPORTING';
export const EXPERIAN = 'EXPERIAN';
export const DISPUTED = 'DISPUTED';
export const TRANS_UNION = 'TRANS';
export const EQUIFAX = 'EQUIFAX';
export const CHAPTER_FILED = 'CHAPTER_FILED';
export const PATIENT_TYPE = 'PATIENT_TYPE';
export const GENDER = 'GENDER';
export const DOC_TYPE = 'DOC_TYPE';
export const LEGAL_ACTION = 'LEGAL_ACTION';
export const CONTACT_CODE = 'CONTACT_CODE';
export const APPROVAL = 'APPROVAL';
export const DOC_SUB_TYPE_CBS = 'DOC_SUB_TYPE (TYPE-CBS)';
export const UNSUBSCRIBE = 'UNSUBSCRIBE';
export const SEARCH_BY = 'SEARCH_BY';
export const RP_PHONE_TYPE = 'RP_PHONE_TYPE';
export const ACCIDENT_TYPE = 'ACCIDENT_TYPE';
export const PREL = 'P_REL';
export const TYPE = 'STATUTE_TYPE';
export const PARTY = 'PARTY';
export const CLIENT_CLASS = 'CLIENT_CLASS';
export const LOCATION_CODE = 'LOCATION_CODE';
export const LETTER_SERVICE_1000 = 'LETTER_SERVICE(1000)';
export const SPLIT_PAY_METHOD = 'SPLIT_PAY_METHOD';
export const SCRIPT_TABLE = 'SCRIPT_TABLE';
export const CANC_CNTRL_TBL = 'CANC_CNTRL_TBL';
export const CLNT_DISP_LIST = 'CLNT_DISP_LIST';
export const MINIMUM_SETTLEMENT = 'MINIMUM_SETTLEMENT';
export const CLNT_LTR_LIST = 'CLNT_LTR_LIST';
export const INTEREST_TABLE = 'INTEREST_TABLE';
export const INTEREST_FREQUENCY = 'INTEREST_FREQUENCY';
export const INTEREST_STEP_TABLE = 'INTEREST_STEP_TABLE';
export const LIST_FEE_TABLE = 'LIST_FEE_TABLE';
export const RATE_TABLE = 'RATE_TABLE';
export const MONITOR_FEE_TABLE = 'MONITOR_FEE_TABLE';
export const NET_OR_GROSS = 'NET_GROSS';
export const RECEIPT_LETTER_UPDATE = 'RECEIPT_LETTER_UPDATE';
export const RECEIPT_LETTER_ENTRY = 'RECEIPT_LETTER_ENTRY';
export const PAYMENT_USER_DEFINED_WINDOW = 'PAYMENT_USER_DEFINED_WINDOW';
export const APPLY_SEQUENCE_OVERRIDE_TABLE = 'APPLY_SEQUENCE_OVERRIDE_TABLE';
export const LOGIC_BLOCK_SORT = 'LOGIC_BLOCK_SORT';
export const STATEMENT_FREQUENCY = 'STATEMENT_FREQUENCY';
export const STATEMENT_DETAIL_LTR = 'STATEMENT_DETAIL_LTR?';
export const TABLE = 'TABLE';
export const MISC_FEE_FREQUENCY = 'MISC_FEE_FREQUENCY';
export const LETTER_SERIES = 'LETTER_SERIES';
export const MAND_USER_WINDOW = 'MANDATORY_USER_WINDOW';
export const NB_SCREEN = 'NB_SCREEN';
export const INT_BASE = 'INT_BASE';
export const DELINQUENCY_LOGIC_BLOCK = 'DELINQUENCY_LOGIC_BLOCK';
export const ORG_CREDITOR_LOGIC_BLOCK = 'ORG_CREDITOR_LOGIC_BLOCK';
export const NEVER_SELECT_LOGIC = 'EVER_SELECT_LOGIC';
export const ON_HOLD_LOGIC = 'ON_HOLD_LOGIC';
export const RTE_TIE_LOGIC_BLOCK = 'ROUTE_TIE_LOGIC_BLOCK';
export const AGENCY_TIE_RULE = 'AGENCY_TIE_RULE';
export const CONTACT_TYPE = 'CONTACT_TYPE';
export const APPLICATION_SEQUENCE = 'APPLICATION_SEQUENCE';
export const SKP_LOCATOR_SERV_TYPE = 'SKP_LOCATOR_SERV_TYPE';
export const CLIENT_FREQUENCY = 'CLIENT_FREQUENCY';
export const BILL_COURT_COST = 'BILL_COURT_COST';
export const RETRO_EFFECTIVE_DATE = 'RETRO/EFFECTIVE_DATE';
export const REVERSALS = 'REVERSALS';
export const PAYMENT_TYPE = 'PAYMENT_TYPE';
export const ACCOUNT_WORK = 'ACCOUNT_WORK';
export const SUB_BALANCES = 'SUB_BALANCES';
export const SERVICE_TYPE = 'SERVICE_TYPE';
export const PRINT_DB_REFERENCE = 'PRINT_DB_REFERENCE';
export const SEPARATE_CHECKS = 'SEPARATE_CHECKS';
export const SUB_TOTALS = 'SUB_TOTALS';
export const SUM_INT_DIFFERENTLY = 'SUM_INT_DIFFERENTLY';
export const ACTION_TAKEN = 'ACTION_TAKEN';
export const FEE_TYPE = 'FEE_TYPE';
export const COMPANY_TYPE = 'COMPANY_TYPE';
export const LETTER_CONSTANT = 'LETTER_CONSTANT';
export const FIELD_SEPERATOR = 'FIELD_SEPERATOR';
export const DATE_FORMAT = 'DATE_FORMAT';
export const OPERATOR = 'OPERATOR';
export const RECORD_TYPE = 'RECORD_TYPE';
export const FILE_FORMATS = 'FILE_FORMATS';
export const FILE_TYPE = 'FILE_TYPE';
export const EVENT_ACTION = 'EVENT_ACTION';
export const MODULE = 'MODULE';
export const PHASE = 'PHASE';
export const EVENT_ACCESS_METHOD = 'EVENT_ACCESS_METHOD';
export const EVENT_TYPE_TRIGGER = 'EVENT_TYPE_TRIGGER';
export const RETURN_TYPE = 'RETURN_TYPE';
export const EVENT_ACTON = 'EVENT_ACTON';
export const CATEGORY = 'CATEGORY';
export const GHI_DISPOSITION = 'GHI_DISPOSITION';
export const STATUS_CHIPS = 'STATUS_CHIPS';

// Data Manager
export const DATA_UPDATE_FUNCTIONS = 'DATA_UPDATE_FUNCTIONS';
export const NEW_ACCOUNT_FUNCTIONS = 'NEW_ACCOUNT_FUNCTIONS';
export const FOOTER_FUNCTIONS = 'FOOTER_FUNCTIONS';
export const HEADER_FUNCTIONS = 'HEADER_FUNCTIONS';
export const EXPORT_FUNCTIONS = 'EXPORT_FUNCTIONS';
export const NEW_PAYMENT_FUNCTIONS = 'NEW_PAYMENT_FUNCTIONS';
export const DM_DATE_FIELD_FORMATS = 'DM_DATE_FIELD_FORMAT';
export const EXCEPTION_FUNCTIONS = 'EXCEPTION_FUNCTIONS';
export const RECORD_SEPERATOR = 'RECORD_SEPERATOR';
export const DM_ACTIONS = 'DM_ACTIONS';
export const DM_FIELD_SEPERATOR = 'DM_FIELD_SEPERATOR';
export const EXPORT_FORMAT_TYPE = 'EXPORT_FORMAT_TYPE';
// Client Mangement
export const ORG_CLIENT_CLASS = 'ORG_CLIENT_CLASS';
export const INVOICE_TYPE = 'INVOICE_TYPE';
export const ORG_TYPE = 'ORG_TYPE';
// Letter maintenance
export const LETTER_TYPE = 'LETTER_TYPE';
export const LETTER_FOR = 'LETTER_FOR';
export const DELIVERY_METHOD = 'DELIVERY_METHOD';
// Import/Exports Format
export const TEXT_FORMAT = 'TEXT_FORMAT';
export const TIME_FORMAT = 'TIME_FORMAT';
export const AMOUNT_FORMAT = 'AMOUNT_FORMAT';
export const AMOUNT_TYPE = 'AMOUNT_TYPE';
export const PHONE_FORMAT = 'PHONE_FORMAT';
export const SSN = 'SSN';
// Data Repository
export const COMPANY = 'COMPANY';
export const FIELD_GROUP = 'FIELD_GROUP';
export const FIELD_USAGE = 'FIELD_USAGE';
// Review Status
export const MCC_REVIEW_STATUS = 'MCC_REVIEW_STATUS';
// Eligibilty Review status
export const REVIEW_STATUS = 'REVIEW_STATUS';
